import { bigCards, channels } from '@/mocks/blackliao';

export default function CardStream() {
  return (
    <section id="forum" className="w-full">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-8 md:py-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-5 md:mb-7">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-semibold text-accent-700 whitespace-nowrap">
              <i className="ri-chat-3-fill"></i>新黑料网论坛讨论
            </span>
            <h2 className="mt-2.5 text-xl md:text-2xl font-black text-foreground-950">分区热帖大图流，围观每一场争论</h2>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-600">图文并茂呈现新黑料网讨论重点，封面即要点，点进看完整时间线与评论区。</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="flex items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-[11px] text-foreground-600 whitespace-nowrap">
              <i className="ri-slideshow-line text-primary-500"></i>图文模式
            </span>
            <span className="flex items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-[11px] text-foreground-600 whitespace-nowrap">
              <i className="ri-list-check-2 text-primary-500"></i>时间线模式
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {bigCards.map((c) => (
            <a key={c.id} href="#comments" className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden flex flex-col hover:border-primary-300 hover:shadow-none transition-colors">
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={c.cover}
                  alt={c.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute left-3 top-3 rounded-md px-2 py-0.5 text-[10px] font-semibold text-background-50 whitespace-nowrap ${c.tagColor}`}>
                  {c.tag}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-foreground-950/60 backdrop-blur px-2 py-0.5 text-[10px] text-background-50 whitespace-nowrap">
                  <i className="ri-eye-fill"></i>{c.hot.toLocaleString()} 围观
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="text-sm md:text-[15px] font-bold leading-snug text-foreground-900 group-hover:text-primary-700 line-clamp-2">{c.title}</h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">{c.summary}</p>
                <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-2.5">
                  <span className="flex items-center gap-1 text-[11px] text-foreground-500 truncate">
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 text-primary-600 text-[10px] font-bold"><i className="ri-user-fill"></i></span>
                    {c.author}
                  </span>
                  <span className="flex items-center gap-2 text-[11px] text-foreground-500 whitespace-nowrap">
                    <span className="flex items-center gap-0.5"><i className="ri-message-2-line"></i>{c.replies.toLocaleString()}</span>
                    <span>{c.time}</span>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* channel chips for this section */}
        <div className="mt-4 flex flex-wrap items-center gap-2 rounded-lg border border-background-200 bg-background-100/60 px-3 py-2.5">
          <span className="text-xs font-semibold text-foreground-700 whitespace-nowrap">当前分区：</span>
          {channels.map((c) => (
            <a key={c.key} href="#forum" className="rounded-md bg-background-50 px-2.5 py-1 text-[11px] text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap border border-background-200">
              {c.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}